import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import Price from "./Price";
import ProductPriceSeo from "./ProductPriceSeo";
import { useIntl, defineMessages } from "react-intl";
import classNames from "classnames";
import { graphql } from "react-apollo";
import ProductPriceQuery from "./ProductPriceQuery.gql";
import { compose } from "recompose";
import ConvertedPrice from "./ConvertedPrice";

const ProductPrice = ({
  prices,
  prefix,
  forceFinalPrice,
  appearance,
  usCadConversionRate,
  ...props
}) => {
  const intl = useIntl();
  if (!prices) {
    return null;
  }

  // Vérifier si le client a une adresse de facturation au Canada
  const isCanadianCustomer =
    props.data?.me?.default_billing?.country_id === "CA";

  if (!usCadConversionRate && isCanadianCustomer) {
    usCadConversionRate = props.data.us_cad_conversion_rate;
  }

  const messages = defineMessages({
    ht: {
      id: "Layout.HT",
      defaultMessage: "Excl. tax",
    },
  });
  const { regularPrice, finalPrice, minPrice } = prices;

  if (!isCanadianCustomer) {
    usCadConversionRate = null;
  }

  if (
    !forceFinalPrice &&
    minPrice?.priceInclTax?.value?.amount &&
    minPrice?.priceInclTax?.value?.amount > finalPrice.priceInclTax.value.amount
  ) {
    return (
      <div
        className={classNames("product-price", `product-price--${appearance}`)}
      >
        <div className="product-price__price">
          <span className="product-price__prefix">
            <FormattedMessage
              id="components.atoms.Typography.Price.ProductPrice.min"
              defaultMessage="As low as"
            />
          </span>
          <span className="product-price__regular">
            <Price price={minPrice.priceExclTax} />{" "}
            {isCanadianCustomer ? (
              <ConvertedPrice price={minPrice.priceExclTax} />
            ) : (
              ""
            )}
            {intl.formatMessage(messages.ht)}
          </span>
        </div>
      </div>
    );
  }
  if (
    regularPrice.priceInclTax.value.amount <=
    finalPrice.priceInclTax.value.amount
  ) {
    return (
      <div
        className={classNames("product-price", `product-price--${appearance}`)}
      >
        <div className="product-price__price">
          {prefix && <span className="product-price__prefix">{prefix}</span>}
          <span className="product-price__regular">
            <Price price={finalPrice.priceExclTax} />{" "}
            {isCanadianCustomer ? (
              <ConvertedPrice price={finalPrice.priceExclTax} />
            ) : (
              ""
            )}
            {intl.formatMessage(messages.ht)}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div
      className={classNames(
        "product-price product-price--special",
        `product-price--${appearance}`
      )}
    >
      <ProductPriceSeo prices={prices} />
      <div className="product-price__price">
        {prefix && <span className="product-price__prefix">{prefix}</span>}
        <span className="product-price__special">
          <Price price={finalPrice.priceExclTax} />{" "}
          {isCanadianCustomer ? (
            <ConvertedPrice price={finalPrice.priceExclTax} />
          ) : (
            ""
          )}
          {intl.formatMessage(messages.ht)}
        </span>
        <span className="product-price__regular" aria-disabled={true}>
          <Price price={regularPrice.priceExclTax} />{" "}
          {isCanadianCustomer ? (
            <ConvertedPrice price={regularPrice.priceExclTax} />
          ) : (
            ""
          )}
          {intl.formatMessage(messages.ht)}
        </span>
      </div>
    </div>
  );
};

ProductPrice.propTypes = {
  prices: PropTypes.shape({
    regularPrice: PropTypes.shape({
      priceInclTax: Price.propTypes.price,
    }).isRequired,
    finalPrice: PropTypes.shape({
      priceInclTax: Price.propTypes.price,
    }).isRequired,
  }).isRequired,
  prefix: PropTypes.node,
  appearance: PropTypes.string,
  usCadConversionRate: PropTypes.string,
};

export default compose(
  graphql(ProductPriceQuery, {
    name: "data",
  })
)(ProductPrice);
